// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9a43d8cc","455":"fbbaa32d","977":"42f4cddf"}[chunkId] + ".chunk.js";
};